import React, { Component } from 'react';

class CategorySelect extends Component {
  _handleInputChange(e) {
  	this.props.selectCategory(e);
  }

  render() {
    return (
      <div className="categoryselect__wrapper">
      	<div className="categoryselect__radio" style={{fontWeight: this.props.value === "" ? 'bold' : 'normal'}}>
      		<label>
      		<input
      			type="radio"
      			value=""
      			onChange={(e) => this._handleInputChange(e)}
      			checked={this.props.value === ""}
      			/>
	      		Alle trossamfund og menigheder
	      	</label>
	    </div>
      	<div className="categoryselect__radio" style={{fontWeight: this.props.value === "1" ? 'bold' : 'normal'}}>
      		<label>
      		<input
      			type="radio"
      			value="1"
            name="Buddhistiske trossamfund og menigheder"
      			onChange={(e) => this._handleInputChange(e)}
      			checked={this.props.value === "1"}
      			/>
	      		Buddhistiske
	      	</label>
	    </div>
      	<div className="categoryselect__radio" style={{fontWeight: this.props.value === "2" ? 'bold' : 'normal'}}>
      		<label>
      		<input
      			type="radio"
      			value="2"
            name="Hinduistiske trossamfund og menigheder"
      			onChange={(e) => this._handleInputChange(e)}
      			checked={this.props.value === "2"}
      			 />
	      		Hinduistiske
	      	</label>
	    </div>
      	<div className="categoryselect__radio" style={{fontWeight: this.props.value === "3" ? 'bold' : 'normal'}}>
      		<label>
      		<input
      			type="radio"
      			value="3"
            name="Islamiske trossamfund og menigheder"
      			onChange={(e) => this._handleInputChange(e)}
      			checked={this.props.value === "3"}
      			/>
	      		Islamiske
	      	</label>
	    </div>
      	<div className="categoryselect__radio" style={{fontWeight: this.props.value === "4" ? 'bold' : 'normal'}}>
      		<label>
      		<input
      			type="radio"
      			value="4"
            name="Jødiske trossamfund og menigheder"
      			onChange={(e) => this._handleInputChange(e)}
      			checked={this.props.value === "4"}
      			 />
	      		Jødiske
	      	</label>
	    </div>
      	<div className="categoryselect__radio" style={{fontWeight: this.props.value === "5" ? 'bold' : 'normal'}}>
      		<label>
      		<input
      			type="radio"
      			value="5"
            name="Kristne trossamfund og menigheder"
      			onChange={(e) => this._handleInputChange(e)}
      			checked={this.props.value === "5"}
      			/>
	      		Kristne
	      	</label>
	    </div>
      	<div className="categoryselect__radio" style={{fontWeight: this.props.value === "6" ? 'bold' : 'normal'}}>
      		<label>
      		<input
      			type="radio"
      			value="6"
            name="Øvrige trossamfund og menigheder"
      			onChange={(e) => this._handleInputChange(e)}
      			checked={this.props.value === "6"}
      			/>
	      		Øvrige
	      	</label>
	    </div>
      </div>
    );
  }
}

export default CategorySelect;


// WEBPACK FOOTER //
// ./src/modules/common/CategorySelect.js